export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";